<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */
    import MediaInteractionImpl from './MediaInteractionImpl.svelte';
    import { getItemSettingsStore } from '../../itemsSettingsStore.js';
    import { hasClass } from '../util/attributes.js';
    import { getItemSequentialInteractionsStore } from '../../itemsSequentialInteractionsStore.js';

    let props = $props();
    // svelte-ignore state_referenced_locally
    let { itemIdentifier, responseIdentifier, autostart, classes = '' } = props;

    const isSequential = autostart && hasClass(classes, 'sequential');
    const sequentialInteractionsStore = getItemSequentialInteractionsStore(itemIdentifier);

    if (isSequential) {
        sequentialInteractionsStore.register(responseIdentifier);
    }

    const itemSettingsStore = getItemSettingsStore(itemIdentifier);

    //remount the interaction outside of usual item lifecycle
    let doNotPlayMedia = $derived(!!$itemSettingsStore.doNotPlayMedia);
</script>

{#key doNotPlayMedia}
    {#if !doNotPlayMedia}
        <MediaInteractionImpl {...props} />
    {/if}
{/key}
